<div appFlex class="w-100-p" *ngIf="(fullSearchService.fullSearchState$|async) as state">

  <div *ngIf="state.ux.barIsDisplayed" appFlex="grow" class="container bar-displayed w-100-p">
    <div appFlex appFlexAlign="end center" class="search-place w-100-p">
      <div appFlex class="search-input-container h-100-p p-8 search w-100-p">
        <input (focusout)="lostFocus()" class="search-input w-100-p" #searchValue
          [placeholder]="'Rechercher...'|translate" matInput type="text" [formControl]="fSearch.get(['value'])">
      </div>

    </div>
  </div>

  <button *ngIf="!state.ux.barIsDisplayed" mat-icon-button (click)="toggleSearch()">
    <mat-icon class="material-icons-outlined secondary-text" style="font-size: 24px;">screen_search_desktop</mat-icon>
  </button>

  <ng-template cdk-portal="">

    <div appFlexLayout="column" class="full-search-result-panel w-100-p">

      <ng-container *ngIf="state.ux.displayHistory; else displayResults">

        <div appFlex appFlexLayout class="search-history w-100-p">
          <app-generic-list [dataSource]="appUserContextService.searchHistory$|async" [columns]="searchHistoryColumns"
            [canRefresh]="false" [actions]="historyListActions" (action)="historyListActionsCall($event)"
            (selectionChanged)="historyChoose($event)" keyExpr="keyword" [showColumnHeaders]="false"
            [displaySearch]="false">
          </app-generic-list>
        </div>

      </ng-container>

      <ng-template #displayResults>

        <div appFlex appFlexLayout="column" appFlexAlign="center center" class="no-result">

          <div appFlex *ngIf="!state.results.length && !state.ux.searching">
            <h2>{{'Pas de résultat'|translate}}</h2>
          </div>

          <div *ngIf="state.ux.searching" appFlex appFlexLayout appFlexAlign="center center">
            <div class="mr-8" appFlex appFlexAlign="end center">
              <mat-spinner [diameter]="24"></mat-spinner>
            </div>
            <span appFlex appFlexAlign="start center">
              <h2>
                {{'Recherche'|translate}}...
              </h2>
            </span>
          </div>

        </div>

        <ng-container *ngIf="state.results.length > 0">

          <div class="group-by" appFlex appFlexLayout="row">
            <button mat-stroked-button [class.primary]="selectedfilterEntity === aEntity"
              (click)="filterEntityClass(aEntity)" class="group mr-8"
              *ngFor="let aEntity of state.resultsCountByEntity.entities">
              <mat-icon fontSet="material-icons-outlined" style="font-size: 24px;">search</mat-icon>
              <span class="ml-4 nb">{{state.resultsCountByEntity.countBy[aEntity]}}</span>
            </button>
            <span appFlex="grow"></span>
            <button mat-icon-button (click)="displayHistory()">
              <mat-icon style="font-size: 24px;">history</mat-icon>
            </button>
          </div>
          <app-generic-list [toolbarTitle]="state.results.length + ' ' + ('éléments trouvés'|translate)"
            [canRefresh]="false" [displaySearch]="false" [canExportExcel]="true" [dataSource]="state.results"
            [keyExpr]="'id'" [columns]="baseColumns" [firstExternalTemplate]="firstExternalTemplate"
            [secondExternalTemplate]="secondExternalTemplate" [thirdExternalTemplate]="thirdExternalTemplate"
            [filterValue]="filterValue">
          </app-generic-list>

          <ng-template #firstExternalTemplate let-rowData="rowData">

            <div appFlexLayout="row" appFlexAlign="start center">

              <app-surveys-actions *ngIf="rowData.entity === 'surveys'" [displaySurveyId]="true"
                [enhanceDefaultAction]="false" [survey]="rowData" [actionsToDisplay]="'EVRA'"
                [disableButtonToolTips]="true">
              </app-surveys-actions>

              <button mat-stroked-button class="p-16" *ngIf="rowData.entity !== 'surveys'" appFlex appFlexLayout="row"
                appFlexAlign="start center" (click)="doEntityAction(rowData)">
                <mat-icon fontSet="material-icons-outlined"
                  style="font-size: 24px;">{{refTypesMatIcons[rowData.entity]}}</mat-icon>
                {{rowData.entity | ucwords}}
              </button>

            </div>
          </ng-template>

          <ng-template #secondExternalTemplate let-rowData="rowData">

            <div *ngIf="rowData.entity === 'surveys'">
              <span appFlex>{{rowData.id}}</span>
            </div>

            <div *ngIf="rowData.entity === 'contributors'">
              <span appFlex>{{rowData.id.split('_')[1]}}</span>
            </div>

            <div *ngIf="rowData.entity === 'dashboards' || rowData.entity === 'publications'">
              <span appFlex>{{rowData.surveyId}}</span>
            </div>

          </ng-template>

          <ng-template #thirdExternalTemplate let-rowData="rowData">

            <div
              *ngIf="rowData.entity === 'surveys' || rowData.entity === 'dashboards' || rowData.entity === 'publications'">
              <span appFlex>
                <button mat-stroked-button [matTooltip]="'Ajouter le projet au contexte actuel'|translate"
                  (click)="addProjectContext($event, rowData.organizationId, rowData.projectId)">
                  <mat-icon style="font-size: 24px;">create_new_folder</mat-icon>
                  {{rowData.projectTitle}}
                </button>
              </span>
            </div>

          </ng-template>


        </ng-container>

      </ng-template>


    </div>
  </ng-template>

</div>
